import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {fetchCommentsModeration, resetCommentsModeration} from "../../../../creators/user.comments.moderation";

import Pagination from "../../../components/Pagination";
import ModerationPopup from "../ModerationPopup";
import Modal from "../../../components/Modal";
import Aqp from "../../../../libs/mk-react-aqp";
import createLink from "../../../../libs/createLink";
import {PageLoader} from "../../../components/Loader";

class ItemModeration extends React.Component {
    constructor(props){
        super(props);
        this.filter = {
            page: 1,
            limit: 28,
        };
         this.types = {
            medias : "commentsModeration",
            status : "commentsModerationStatus",
            articles : "commentsModerationArticles",
            stories : "commentsModerationStories"
        };
        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page'],
            currentLink: createLink(this.types[this.props.parentKind]),
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: (this.props.match && this.props.match.params.page) || 1},
            togglePopup: false,
            selectedItem: {}
        };
        this.fetchCommentsModeration(this.state.filter);
    };

    fetchCommentsModeration(filter){
        let query = {...filter};
        this.props.fetchCommentsModeration(this.props.parentKind, this.aqp.set(query));
    }

    componentDidUpdate(prevProps) {
        if(prevProps.parentKind !== this.props.parentKind){
            this.props.resetCommentsModeration();
            this.aqp.setCurrentLink(createLink(this.types[this.props.parentKind]));
            this.fetchCommentsModeration(this.state.filter);

        }
    }

    handleSelectedItem(item){
        this.setState({selectedItem: item, togglePopup: true});
    }

    render(){
        let totalPage = Math.ceil(this.props.itemCommentsTotal.count / this.state.filter.limit);
        let types = {status: "status", stories: "histoire", articles : "article", medias: "media"};
        return !this.props.itemCommentsInitialized ? (
            <PageLoader/>
        ) : (
            <div>
                <div className={`column`}>
                    <div className="media-container">
                        {this.props.itemComments.map((item, index) => {
                            if(item.countNotApprouved !== 0){
                                return (
                                    <div key={index} className="block"
                                         onClick={() => this.handleSelectedItem({...item})}>
                                        <div className="img-container">
                                            <span className="article-content">{types[this.props.parentKind]}</span>
                                            <span className="badge dark">
                                        {item.countNotApprouved} commentaire{item.countNotApprouved > 1 && 's'}
                                    </span>
                                        </div>
                                        <div className="infos column">
                                            <span className="title">{item.text}</span>
                                        </div>
                                    </div>
                                )
                            } else return null;
                        })}
                        {(!this.props.itemCommentsLoading && this.props.itemCommentsTotal === 0) && (
                            <div className="no-content row">
                                Il n'y a aucun{this.props.parentKind === "stories" && "e"} {types[this.props.parentKind]} à modérer pour le moment
                            </div>
                        )}
                        {(this.props.itemCommentsLoading && this.props.itemCommentsTotal === 0) && (
                            <PageLoader />
                        )}
                    </div>
                </div>
                {this.props.itemCommentsMore && (
                    <Pagination
                        currentPage={this.state.filter.page}
                        pagesCount={totalPage}
                        handleChangePage={this.handleChangePage}
                        {...this.aqp.queryUrl(this.state.filter)}
                    />
                )}
                <Modal toggle={this.state.togglePopup}
                       handleClose={() => this.setState({togglePopup: false})}>
                    <ModerationPopup
                        currentSelection={this.state.selectedItem}
                        parentKind={this.props.parentKind}
                        handleClose={() => this.setState({togglePopup: false})}
                    />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        itemComments: state.commentsModeration.data,
        itemCommentsLoading: state.commentsModeration.loading,
        itemCommentsInitialized: state.commentsModeration.initialized,
        itemCommentsMore: state.commentsModeration.more,
        itemCommentsTotal: state.commentsModeration.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCommentsModeration,
    resetCommentsModeration
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemModeration);